import { DARK } from '@core/constants/theme';
import { styled } from '@ublend-npm/aulaui-core';

const EditorContainer = styled('div')(({ theme }) => ({
  width: 'calc(100% - 66.5px)',
  marginLeft: '35.5px',
  '& p': {
    fontFamily: 'Roboto, sans-serif',
    color:
      theme.palette.mode === DARK
        ? 'rgba(255, 255, 255, 0.7)'
        : 'rgba(0, 0, 0, 0.6)',
  },
  fontFamily: 'Roboto, sans-serif',
  '& span': {
    overflowWrap: 'anywhere',
  },
}));

export default EditorContainer;
